import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

import { Appointment, deriveTitleFactory } from '~weekly-planner/lib/common';

import ContainerPanel from '~components/ContainerPanel';
import ModalCard from '~components/ModalCard';
import { getOne as getWorker } from '~dashboard/components/user-calendar/actions/users';
import { selectParams } from '~dashboard/components/user-calendar/selectors';
import { selectAll, selectLoading as selectUsersLoading } from '~dashboard/components/user-calendar/selectors/users';
import { View as WeeklyView } from '~weekly-planner/components/main/weekly';
import WorkerCell from '~weekly-planner/components/main/WorkerCell';

import { getAll as getCareQualificationLevels } from '~appointments/actions/careQualificationLevels';

import { openAppointmentDetails } from '~weekly-planner/reducers/weeklyPlanner';

import Banner from './components/Banner';

dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
  weekStart: 1,
});

const UserCalendar: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useAppSelector(selectParams);

  const workerData = useAppSelector(selectAll);
  const workerDataLoading = useAppSelector(selectUsersLoading);

  const { week_start } = params;

  const [isOpen, setOpen] = useState<boolean>(true);

  const load = (searchParams?: { [key: string]: any }) => {
    if (week_start) {
      dispatch(getWorker({ ...params, ...searchParams }));
    }
  };

  useEffect(() => {
    dispatch(
      getCareQualificationLevels({
        attributes: ['id', 'name', 'colour'],
      }),
    );
    document.addEventListener('click', click);

    return () => {
      document.removeEventListener('click', click);
    };
  }, []);

  useEffect(() => {
    load();
  }, [params]);

  const click = (event: MouseEvent) => {
    const clickTarget = event.target as HTMLElement;
    const appointmentCard = clickTarget.closest('.appointment-card');
    const popover = clickTarget.closest('.popover');

    if (!appointmentCard && !popover) {
      dispatch(openAppointmentDetails(null));
    }
  };

  const getAppointmentTitle = deriveTitleFactory<Appointment, 'client'>('client');

  return (
    <ModalCard
      header="Your Weekly Schedule"
      className="dashboard-modal"
      headerClassName="header fw-bold"
      isOpen={isOpen}
      setIsOpen={() => setOpen(!isOpen)}
    >
      <div className="body-wrapper">
        <div className="week-schedule weekly-planner">
          <Banner onRefresh={load} />
          <ContainerPanel className="main-view">
            <WeeklyView
              headerTitle=""
              headerCell={WorkerCell}
              rows={workerData}
              loadingState={workerDataLoading}
              getAppointmentTitle={getAppointmentTitle}
              isDashboardView={true}
            />
          </ContainerPanel>
        </div>
      </div>
    </ModalCard>
  );
};

export default UserCalendar;
